<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects/accounts'"
            >Accounts</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="
              '/' +
              authUser.userable_type +
              '/projects/account/' +
              accountCode +
              '/' +
              accountID
            "
            >{{ accountCode }}</router-link
          >
        </li>
      </ol>
    </div>
    <spinner v-if="searchingAccount" />

    <div
      v-else
      style="
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 60px;
      "
    >
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            min-height: 75px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            flex-direction: row !important;
          "
        >
          <div style="padding-left: 50px; font-size: 18px" class="col-6">
            {{ accountCode }}
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin-bottom: 15px !important;
            border-top-right-radius: 30px;
            border-top-left-radius: 30px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleAccountDetails()"
              class="col-6"
            >
              Account Details
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showAccountDetails ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showAccountDetails ? 'display: flex' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-8">
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Code</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.code }}
                </label>
              </div>
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Net Balance</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ fixNumberView(activeAccount.current_balance) }}
                </label>
              </div>
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Currency</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.currency.code }}
                </label>
              </div>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleAccountProject()"
              class="col-6"
            >
              Project Details
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showAccountProject ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showAccountProject ? 'display: flex' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-8">
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Project Code</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.project.code }}
                </label>
              </div>
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Project Name</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.project.name }}
                </label>
              </div>
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Project Description</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.project.description }}
                </label>
              </div>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            border-bottom-right-radius: 30px;
            border-bottom-left-radius: 30px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleAccountTransactions()"
              class="col-6"
            >
              Transactions
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showAccountTransactions
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              showAccountTransactions ? 'display: block' : 'display: none'
            "
            style="min-height: 100px"
          >
            <div class="col-12 accountInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Type</th>
                    <th>Category</th>
                    <th>Amount</th>
                    <th>Currency</th>
                    <th>Exchange Rate</th>
                    <th>Fees</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(transaction, key) in activeAccount.transactions"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ transaction.code }}</td>
                    <td>
                      {{ transaction.description }}
                    </td>
                    <td>
                      {{ transaction.type }}
                    </td>
                    <td>
                      {{ transaction.category.name }}
                    </td>
                    <td>
                      {{ fixNumberView(transaction.amount) }}
                    </td>
                    <td>
                      {{ transaction.currency.code }}
                    </td>
                    <td>
                      {{ transaction.exchange_rate }}
                    </td>
                    <td>
                      {{ fixNumberView(transaction.fees) }}
                    </td>
                    <td>
                      {{ transaction.date }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from "vue-simple-spinner";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import ProjectAccountsFilter from "../../filters/ProjectAccountsFilter";
import TransactionsFilter from "../../filters/TransactionsFilter";
import moment from "moment";

export default {
  name: "account",
  data() {
    return {
      showAccountTransactions: false,
      showAccountDetails: false,
      showAccountProject: false,
      accountID: null,
      accountCode: null,
    };
  },
  created: function () {
    this.accountID = this.$route.params.accountId;
    this.accountCode = this.$route.params.accountCode;
    var accountsFilter = ProjectAccountsFilter();
    accountsFilter.ids = [this.accountID];
    accountsFilter.with = ["project", "transactions"];
    this.$store.dispatch("searchProjectAccounts", {
      filter: accountsFilter,
      resultMode: "default",
    });
  },
  components: {
    Spinner,
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      activeAccount: (state) =>
        state.accountsStore.projectAccountSearch.projectAccounts[0],
      searchingAccount: (state) =>
        state.accountsStore.projectAccountSearch.searchingProjectAccounts,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    toggleAccountTransactions() {
      this.showAccountTransactions = !this.showAccountTransactions;
    },
    toggleAccountDetails() {
      this.showAccountDetails = !this.showAccountDetails;
    },
    toggleAccountProject() {
      this.showAccountProject = !this.showAccountProject;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    dateDifference(date2, date1) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      // Discard the time and time-zone information.
      const utc1 = Date.UTC(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
      );
      const utc2 = Date.UTC(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
      );

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
    deleteAccount() {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this account?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteAccount", this.activeAccount.id);
        }
      });
    },
  },
  watch: {
    deleteAccountStatus() {
      if (this.deleteAccountStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Account has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/accounts");
        });
      } else if (this.deleteAccountStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Account delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style>
.accountInfoClass {
  padding-left: 75px;
  display: flex;
  align-items: start;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/projectAccount.vue